import React from 'react';

import { FreeTrialBanner } from '~features/FreeTrial';
import {
  SubscriptionCancelledBanner,
  SubscriptionScheduledCancellationBanner,
  UnpaidInvoicesBanner,
} from '~features/billing';

function AlertsContainer() {
  return (
    <>
      <UnpaidInvoicesBanner />
      <SubscriptionCancelledBanner />
      <SubscriptionScheduledCancellationBanner />
      <FreeTrialBanner />
    </>
  );
}

export default AlertsContainer;
